export default "__VITE_ASSET__BivZ2N24__"